<!-- 确认认证接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "authId": 1,
                "authDate": "20190423090000",
                "authBy": "operator",
                "reason": "照片灰暗",
                "authType": 0,
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,确认认证",
                t_url: this.commonUrls.test+"authenticateConfirm",
                p_url: this.commonUrls.prod+"authenticateConfirm",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'authId', info2: '否', info3: 'Long', info4: '认证记录id，authId和phone、carNO两组必传其一' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '用户手机号码，authId和phone、carNO两组必传其一' },
                        { info1: 'carNO', info2: '否', info3: 'String', info4: '用户绑定的车牌号码，authId和phone、carNO两组必传其一' },
                        { info1: 'authDate', info2: '是', info3: 'String', info4: '操作时间，yyyyMMddHHmmss' },
                        { info1: 'authBy', info2: '是', info3: 'String', info4: '操作人' },
                        { info1: 'reason', info2: '否', info3: 'String', info4: '审核不通过原因' },
                        { info1: 'authType', info2: '是', info3: 'Integer', info4: '认证状态。0认证不通过 1认证通过' },
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [

                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/authenticateConfirm.vue